import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-741b81e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_3 = { class: "config" }
const _hoisted_4 = { class: "search-form" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_6 = { key: 0 }

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import RoadmapService from '@/services/RoadmapService'
import RoadmapInterface from '@/interfaces/RoadmapInterface'
import { useAuth } from '@/store/useAuth'
import FollowRoadmapService from '@/services/FollowRoadmapService'
import main from '@/data/main.js'

import { defineAsyncComponent, onMounted, ref, Ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MyRoadmapsView',
  setup(__props) {

const loading: Ref<boolean> = ref(true)
const search: Ref<string> = ref('')
const roadmapsFolows = ref([])
const roadmaps:Ref<any> = ref([])
const filteredRoadmaps: Ref<Array<RoadmapInterface>> = ref([])
const store = useAuth()
const followRoadMapService = new FollowRoadmapService()
const CardLayout = defineAsyncComponent(() => import('@/layouts/RoadmapCardLayout.vue'))
const TableLayout = defineAsyncComponent(() => import('@/layouts/RoadmapTableLayout.vue'))
const ListLayout = defineAsyncComponent(() => import('@/layouts/RoadmapListLayout.vue'))

const layout = ref(CardLayout)

const handleComponent = (cmp: any) => layout.value = cmp

const roadmapService = new RoadmapService()

onMounted(async () => {
    loading.value = true
    if (store.token) {
        roadmapsFolows.value = await followRoadMapService.getAllRoadmapsFromUser(store.token)
    }
    roadmapsFolows.value.forEach(async (roadmap:any) => {
        const item:Ref<any> = await roadmapService.GetRoadmap(roadmap.roadmap_id)
        roadmaps.value.push(item)
    });
    Promise.all(roadmaps.value)
    filteredRoadmaps.value = roadmaps.value
    loading.value = false
})

const handleSearch = () => {
    loading.value = true
    filteredRoadmaps.value = roadmaps.value.filter((item:any) => item.title.toLowerCase().includes(search.value.toLowerCase()))
    loading.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", null, _toDisplayString(_unref(main).TITLE_ROADMAP_VIEW), 1),
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", _hoisted_4, [
            _createVNode(_component_v_icon, { name: "fa-filter" }),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
              placeholder: "Escribe aquí para filtrar las Itinerarios Formativos.",
              onKeyup: handleSearch
            }, null, 544), [
              [_vModelText, search.value]
            ])
          ])
        ]),
        _hoisted_5,
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_v_icon, {
                name: "ri-loader-2-fill",
                animation: "spin",
                class: "icon"
              })
            ]))
          : (_openBlock(), _createBlock(_resolveDynamicComponent(layout.value), {
              key: 1,
              content: filteredRoadmaps.value
            }, null, 8, ["content"]))
      ])
    ]),
    _: 1
  }))
}
}

})